import React, { useContext, useState } from 'react';

import CMTextButton from '../../../components/cm-text-button/cm-text-button.component';

import { AuthContext } from '../../../context/auth/auth.context';
import { SnackbarContext } from '../../../context/snackbar/snackbar.context';

import { makePermanent } from '../../../services/users/users.service';

const AdminMakePermanent = ({ fullName, userId, testid, onSuccess }) => {
  const { authToken } = useContext(AuthContext);
  const { showSnackbar } = useContext(SnackbarContext);

  const [loading, setLoading] = useState(false);

  const handleMakePermanent = () => {
    if (
      !window.confirm(
        `The state of ${fullName} will be changed to Permanent. Are you sure?`
      )
    )
      return;

    setLoading(true);
    makePermanent(userId, authToken)
      .then(() => {
        showSnackbar({
          severity: 'success',
          message: `State of ${fullName} changed to permanent.`,
        });
        onSuccess();
      })
      .catch(err => {
        const errorMessage = err?.response?.data?.args?.[0] ?? '';
        const formattedErrorMessage = errorMessage
          .replace('! check_args - ', '')
          .replace(/[{}]/g, '');
        showSnackbar({
          severity: 'error',
          message: formattedErrorMessage || 'Something wrong happened.',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <CMTextButton
      data-testid={`${testid}.makePermanentButton`}
      onClick={handleMakePermanent}
      loading={loading}
      disabled={loading}
    >
      Make Permanent
    </CMTextButton>
  );
};

export default AdminMakePermanent;
